import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorMutationKeys } from '../../../keys'
import { deleteMember } from '../../services'

interface UseMutationDeleteMemberProps {
	id: string
}

export default function useMutationDeleteMember(
	props?: UseBaseMutationOptions<void, UseMutationDeleteMemberProps>,
) {
	return useMutation({
		mutationKey: [OperatorMutationKeys.DeleteMember],
		mutationFn: ({ id }) => deleteMember(id),
		...props,
	})
}
